import React, { useCallback, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import { Header } from "./components/Header";
import { Drawer } from "./components/Drawer";
import { authClient } from "./auth-client";
import { AppRoutes } from "./AppRoutes";

function App() {
  const { data: session, isPending } = authClient.useSession();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = useCallback(() => setIsDrawerOpen((open) => !open), []);

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-secondary-600">Loading...</div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-secondary-50">
        {session && (
          <>
            <Header
              toggleDrawer={toggleDrawer}
              userEmail={session?.user?.email ?? ""}
            />
            <Drawer
              isOpen={isDrawerOpen}
              onClose={() => setIsDrawerOpen(false)}
            />
          </>
        )}
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;
